<!-- =========================================================================================
  File Name: UserEditTabInformation.vue
  Description: User Edit Information Tab content
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div>
    <vx-card>
      <ValidationObserver v-slot="{ handleSubmit }" ref="form">
        <form @submit.prevent="handleSubmit">
          <div class="vx-row">
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.prefix')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.master.dataForm.prefix') }}*</label>
                <v-select v-model="form.prefix" :clearable="false" :options="prefixOptions" :name="$t('sections.master.dataForm.prefix')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.name')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.name") }}*</label>
                <vs-input type="text" v-model="form.name" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/3 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.surname')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{$t('sections.master.dataForm.surname')}}*</label>
                <vs-input type="text" v-model="form.surname" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/6 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.status')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t('sections.master.dataForm.status') }}*</label>
                <v-select v-model="form.status" :clearable="false" :options="statusesOptions" :name="$t('sections.master.dataForm.status')" :reduce="res => res.value" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>
          <div class="vx-row">
            <div class="vx-col w-1/2 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.position')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.position") }}*</label>
                <vs-input type="text" v-model="form.position" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
            <div class="vx-col w-1/2 mt-5">
              <validation-provider :name="$t('sections.master.dataForm.phone')" rules="required" v-slot="{ errors }">
                <label class="vs-input--label">{{ $t("sections.master.dataForm.phone") }}*</label>
                <vs-input type="text" v-model="form.phone" class="w-full" />
                <span class="text-danger text-sm">{{ errors[0] }}</span>
              </validation-provider>
            </div>
          </div>

          <!-- Save & Reset Button -->
          <div class="vx-row">
            <div class="vx-col w-full">
              <div class="mt-8 flex flex-wrap items-center justify-end">
                <vs-button class="ml-auto mt-2" @click="submit">{{ $t("sections.master.dataForm.action.btnSave") }}</vs-button>
                <vs-button class="ml-4 mt-2" type="border" color="warning" @click="reset">{{ $t("sections.master.dataForm.action.btnReset") }}</vs-button>
              </div>
            </div>
          </div>
        </form>
      </ValidationObserver>
    </vx-card>
  </div>
</template>

<script>
import vSelect from 'vue-select'
import { ValidationProvider } from 'vee-validate'
import { createNamespacedHelpers, mapGetters } from 'vuex'

const {mapActions: mapMasterActions, mapState:  mapMasterFields} = createNamespacedHelpers('Master')

export default {
  components: {
    vSelect,
    ValidationProvider
  },

  data () {
    return {
      form:{
        prefix: '',
        name: '',
        surname: '',
        position: '',
        phone: '',
        status: 'Enabled',
      }
    }
  },
  async created () {
    const vm = this;
    const { getPrefixOptions } = vm
    await getPrefixOptions()
    await this.getSigner({form: {id: this.$route.params.id}})
    this.pms ('MasterSigner', 'edit', 'r')
    this.reset ()
  },
  computed: {
    ...mapMasterFields(['status', 'signer']),
    ...mapGetters({
      prefixOptions :'Master/prefixOptions',
      statusesOptions :'Master/statusesOptions'
    })
  },
  methods: {
    ...mapMasterActions(['getPrefixOptions', 'getSigner', 'updateSigner']),
    async submit () {
      const vm = this
      vm.$refs['form'].validate().then(success => {
        if (!success) {
          return
        }

        this.updateSigner({
          id: vm.$route.params.id,
          form: {
            prefix: {id: vm.form.prefix},
            name: vm.form.name,
            surname: vm.form.surname,
            position: vm.form.position,
            phone: vm.form.phone,
            status: vm.form.status,
          },
          vm,
          redirect: "/master/signer"
        })
      })
    },
    reset () {
      const vm = this
      vm.form = {
        prefix: (vm.signer.prefix ? vm.signer.prefix.id : ''),
        name: vm.signer.name,
        surname: vm.signer.surname,
        email: vm.signer.email,
        position: vm.signer.position,
        phone: vm.signer.phone,
        status: vm.signer.status
      }
    }
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
  },
}
</script>
